/* eslint-disable  */
import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import actions from 'redux/actions';

const { getCountriesAvailable } = actions;

export default () => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer, shallowEqual);
  const othersReducer = useSelector((state) => state.othersReducer, shallowEqual);
  const { isLogin } = authReducer;
  const { listCountries } = othersReducer;
  return useEffect(() => {
    if (isLogin && !listCountries) {
      dispatch(getCountriesAvailable());
    }
  }, [isLogin]);
};
